import React, { useEffect, useState } from 'react';
import Uppy from '@uppy/core';
import { DragDrop, StatusBar } from '@uppy/react';
import XHR from '@uppy/xhr-upload';

import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';

import { useSelector } from "react-redux";
import { selectCurrentLang, selectTranslations } from "../../services/i18n/i18nSlice";

import '../_modals/modalStyle.css'

import '@uppy/core/dist/style.min.css';
import '@uppy/drag-drop/dist/style.min.css';
import '@uppy/status-bar/dist/style.min.css';

import { API_URL } from '../../config/constants';
import { randomUid } from '../../utils/utils';

export default function QuestionsUploader (props) {

    const t = useSelector(selectTranslations)
    const currentLang = useSelector(selectCurrentLang)

    const [uppy] = useState(() => new Uppy({id:randomUid(), debug: true, autoProceed:true, locale:currentLang})
            .use(XHR, { 
                endpoint: API_URL + props.endpoint,
                withCredentials: true,
                getResponseError (responseText, response) {
                    const error = JSON.parse(responseText)
                    toast.error(error.detail)
                },
                getResponseData (responseText) {
                    console.log(responseText)
                    if(responseText === '"ok"')
                        props.onUploadComplete()
                }
            }));


    return (
        <>
        <Modal
            show={props.show}
            onHide={props.onClose}  
            centered
        >
            <Modal.Body>
                <h3 className='mb-2'>{t.question.excel_import}</h3>
                <DragDrop uppy={uppy} />
                <StatusBar hideAfterFinish={true} uppy={uppy} />
            </Modal.Body>
        </Modal>
        </>
        
    )
}